// Dashboard.js

import React, { useState, useEffect } from 'react';
import {
  AppBar,
  Avatar,
  Box,
  Menu,
  MenuItem,
  IconButton,
  Divider,
  Toolbar,
  Tooltip,
  Typography,
} from '@mui/material';
import MenuIcon from "@mui/icons-material/Menu";
import axios from 'axios';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import 'dayjs/locale/pt-br';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

import Goals from './goal/Goals';
import GoalStepper from './goal/GoalStepper';
import Login from './Login';
import Filter from './Filter';
import AttendanceFlowChart from './AttendanceFlowChart';
import HorizontalBarReasons from './HorizontalBarReasons';
import UsersCard from './UsersCard';
import TimelineUsers from './TimelineUsers';
import SalesReport from './SalesReport';

dayjs.locale('pt-br');

dayjs.extend(utc);
dayjs.extend(timezone);

const empresas = [
  // { id: 'e1', nome: 'Empresa 1' },
  // { id: 'e2', nome: 'Empresa 2' },
];

const users = [
  // { id: 'v1', nome: 'João', empresaId: 'e1', imagem: 'https://i.pravatar.cc/150?img=1' },
  // { id: 'v2', nome: 'Maria', empresaId: 'e1', imagem: 'https://i.pravatar.cc/150?img=2' },
  // { id: 'v3', nome: 'Pedro', empresaId: 'e2', imagem: 'https://i.pravatar.cc/150?img=4' },
];

const startParams = {
  "dialogOptions": {
    "available_inService": {
      "label": "Por que está atendendo?",
      "options": [
        {
          "label": "Operacional",
          "value": "operacional",
          "icon": "Build",
          "options": [
            {
              "label": "Equipe indisponível",
              "value": "equipe_indisponivel",
              "icon": "GroupOff",
              "options": [
                {
                  "label": "Doença",
                  "value": "LocalHospital",
                  "returnTo": "end",
                  "icon": "LocalHospital"
                },
                {
                  "label": "Férias",
                  "value": "ferias",
                  "returnTo": "end",
                  "icon": "BeachAccess"
                }
              ]
            },
            {
              "label": "Problemas técnicos",
              "value": "problemasTecnicos",
              "returnTo": "end",
              "icon": "BugReport"
            }
          ]
        },
        {
          "label": "Preferência do cliente",
          "value": "preferencia_cliente",
          "returnTo": "end",
          "icon": "ShoppingCart",
          "options": []
        },
        {
          "label": "Retorno cliente",
          "value": "retorno_cliente",
          "returnTo": "end",
          "icon": "Autorenew",
          "options": []
        }
      ]
    },
    "inService_available": {
      "label": "Por que está voltando para a fila?",
      "options": [
        {
          "label": "Não convertido",
          "value": "naoConvertido",
          "icon": "Cancel",
          "options": [
            {
              "label": "Cor",
              "value": "naoConvertido_cor",
              "returnTo": "end",
              "icon": "Palette"
            },
            {
              "label": "Entrou e saiu",
              "value": "naoConvertido_entrouesaiu",
              "icon": "ExitToApp",
              "options": [
                {
                  "label": "Não deu atenção",
                  "value": "naoConvertido_entrouesaiu_naoDeuAtencao",
                  "returnTo": "end",
                  "icon": "VisibilityOff"
                },
                {
                  "label": "Não deu tempo de abordar",
                  "value": "naoConvertido_entrouesaiu_naoDeuTempo",
                  "returnTo": "end",
                  "icon": "HourglassTop"
                }
              ]
            },
            {
              "label": "Não agradou",
              "value": "naoConvertido_naoAgradou",
              "returnTo": "end",
              "icon": "SentimentDissatisfied"
            },
            {
              "label": "Não trabalha com o produto",
              "value": "naoConvertido_naoTrabalhaComProduto",
              "returnTo": "end",
              "icon": "DoNotDisturb"
            },
            {
              "label": "Pagamento",
              "value": "naoConvertido_pagamento",
              "returnTo": "end",
              "icon": "AttachMoney"
            },
            {
              "label": "Pesquisa",
              "value": "naoConvertido_pesquisa",
              "icon": "Search",
              "options": [
                {
                  "label": "Para presente",
                  "value": "naoConvertido_pesquisa_paraPresente",
                  "returnTo": "end",
                  "icon": "Redeem"
                },
                {
                  "label": "Para o próprio cliente",
                  "value": "naoConvertido_pesquisa_paraOProprio",
                  "returnTo": "end",
                  "icon": "Person"
                }
              ]
            },
            {
              "label": "Preço",
              "value": "naoConvertido_preco",
              "returnTo": "end",
              "icon": "AttachMoney"
            },
            {
              "label": "Reserva",
              "value": "naoConvertido_reserva",
              "returnTo": "end",
              "icon": "Event"
            },
            {
              "label": "Sem estoque",
              "value": "naoConvertido_semEstoque",
              "returnTo": "end",
              "icon": "RemoveShoppingCart"
            },
            {
              "label": "Tamanho",
              "value": "naoConvertido_tamanho",
              "returnTo": "end",
              "icon": "Height"
            }
          ]
        },
        {
          "label": "Sucesso",
          "value": "sucesso",
          "returnTo": "end",
          "icon": "CheckCircle"
        },
        {
          "label": "Troca",
          "value": "troca",
          "icon": "SwapHoriz",
          "options": [
            {
              "label": "Troca não convertida",
              "value": "troca_naoConvertida",
              "returnTo": "end",
              "icon": "RemoveCircle"
            },
            {
              "label": "Troca normal",
              "value": "troca_normal",
              "returnTo": "end",
              "icon": "CompareArrows"
            },
            {
              "label": "Troca sucesso",
              "value": "troca_sucesso",
              "returnTo": "end",
              "icon": "CheckCircleOutline"
            }
          ]
        },
        {
          "label": "Outros",
          "value": "outros",
          "icon": "MoreHoriz",
          "options": [
            {
              "label": "Cancelar atendimento",
              "value": "outros_cancelarAtendimento",
              "returnTo": "end",
              "icon": "Close"
            },
            {
              "label": "Retorno da reserva",
              "value": "outros_retornoDaReserva",
              "returnTo": "end",
              "icon": "Replay"
            },
            {
              "label": "Reserva de outro vendedor",
              "value": "outros_reservaDeOutroVendedor",
              "returnTo": "end",
              "icon": "Assignment"
            },
            {
              "label": "Vendedor fora da vez",
              "value": "outros_foraDaVez",
              "returnTo": "end",
              "icon": "WatchLater"
            }
          ]
        }
      ]
    },
		"available_unavailable": {
      "label": "Por que está saindo?",
      "options": [
        {
          "label": "Finalizar dia",
          "value": "saiu_finalizar",
          "icon": "WavingHand"
        },
        {
          "label": "Almoço/janta",
          "value": "saiu_almoco",
          "icon": "Restaurant"
        },
        {
          "label": "Banheiro",
          "value": "saiu_banheiro",
          "icon": "Wc"
        },
        {
          "label": "Lanche",
          "value": "saiu_lanche",
          "icon": "LunchDining"
        },
        {
          "label": "Outros",
          "value": "saiu_extra",
          "icon": "AssignmentReturn"
        }
      ]
    }
  }
}

function Header({ onLogout, setPage }) {
  const S3_URL = process.env.REACT_APP_S3_URL;
  const user = JSON.parse(localStorage.getItem('user'));
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const changePage = (pageName) => {
    setPage(pageName);
    handleCloseNavMenu();
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    if (onLogout) {
      onLogout();
    } else {
      window.location.reload();
    }
  };

  return (
    <AppBar 
      position="static" 
      sx={{ backgroundColor: "#795548", borderRadius: 2, mb: 2 }}
    >
      <Toolbar>
        {/* Menu Esquerda */}
        <Box sx={{ flexGrow: 1, display: "flex", alignItems: "center" }}>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            onClick={handleOpenNavMenu}
          >
            <MenuIcon />
          </IconButton>
          <Menu
            anchorEl={anchorElNav}
            open={Boolean(anchorElNav)}
            onClose={handleCloseNavMenu}
          >
            <MenuItem onClick={() => changePage('admin')}>Dashboard</MenuItem>
            <MenuItem onClick={() => changePage('goals')}>Metas</MenuItem>
          </Menu>

          <Typography
            variant="h6"
            noWrap
            sx={{ ml: 2, letterSpacing: ".05rem" }}
          >
            Atende
          </Typography>
        </Box>

        {/* Usuário Direita */}
        <Box sx={{ flexGrow: 0, display: "flex", alignItems: "center" }}>
          <Tooltip title="Abrir menu de usuário">
            <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
              <Avatar src={`${S3_URL}/img/user/${user?.avatar_url}`} alt={user?.name} />
            </IconButton>
          </Tooltip>
          <Typography sx={{ ml: 1, fontWeight: 500 }} onClick={handleOpenUserMenu}>
            {user?.name || "Usuário"}
          </Typography>

          <Menu
            anchorEl={anchorElUser}
            open={Boolean(anchorElUser)}
            onClose={handleCloseUserMenu}
            sx={{ mt: "45px" }}
          >
            <MenuItem disabled>{user?.email}</MenuItem>
            <Divider />
            <MenuItem
              onClick={() => {
                handleCloseUserMenu();
                handleLogout();
              }}
            >
              Sair
            </MenuItem>
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  )
}

const Dashboard = () => {

  const [filtros, setFiltros] = useState({
    dataInicial: null,
    dataFinal: null,
    empresasSelecionadas: [],
    vendedoresSelecionados: [],
  });

  const [data, setData] = useState(null);
  const [goals, setGoals] = useState([]);
  const [token, setToken] = useState(localStorage.getItem('token') || null);
  const [page, setPage] = useState('admin');
  const [pageObjectId, setPageObjectId] = useState(null);

  useEffect(() => {
    const { dataInicial, dataFinal, empresasSelecionadas, vendedoresSelecionados } = filtros;

    if (!dataInicial || !dataFinal) return;

    const params = new URLSearchParams();

    // Define o timezone do usuário (ex: São Paulo)
    const userTimezone = 'America/Sao_Paulo';

    // Converte o início do dia local para UTC
    const startUTC = dayjs.tz(dataInicial.startOf('day'), userTimezone).utc().toISOString();
    // Converte o fim do dia local para UTC
    const endUTC = dayjs.tz(dataFinal.endOf('day'), userTimezone).utc().toISOString();

    params.append('start_date', startUTC);
    params.append('end_date', endUTC);

    if (empresasSelecionadas.length > 0) {
      empresasSelecionadas.forEach(id => params.append('company_uuids', id));
    }

    if (vendedoresSelecionados.length > 0) {
      vendedoresSelecionados.forEach(id => params.append('user_uuids', id));
    }

    const fetchData = async () => {
      try {
        const response1 = await axios.get(
          `${process.env.REACT_APP_API_URL}admin/service?${params.toString()}`,
          { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
        );
        setData(response1.data);
        const response2 = await axios.get(
          `${process.env.REACT_APP_API_URL}admin/goal/by-user?start_date=${dayjs(dataInicial).format('YYYY-MM-DD')}&end_date=${dayjs(dataFinal).format('YYYY-MM-DD')}`,
          { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
        );
        setGoals(response2.data);
      } catch (error) {
        if (error.response?.status === 401) {
          console.log('Token inválido ou expirado. Redirecionando para login.');
          setToken(null);
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          window.location.reload();
        }
        console.error('Erro ao buscar atendimentos:', error);
      }
    };

    fetchData();
  // eslint-disable-next-line
  }, [filtros]);

  useEffect(() => {
    setToken(localStorage.getItem('token') || null);
  // eslint-disable-next-line
  }, [localStorage['token']]);

  const handleFilterChange = (novoFiltro) => {
    const filtroAtualStr = JSON.stringify(filtros);
    const novoFiltroStr = JSON.stringify(novoFiltro);
    if (filtroAtualStr !== novoFiltroStr) {
      setFiltros(novoFiltro);
    }
  };

  const reaplicarFiltro = () => {
    setFiltros({ ...filtros }); // Apenas dispara novamente o useEffect
  };

  const goalOpen = (goalId) => {
    setPageObjectId(goalId);
    setPage('goal');
  }

  if (!token) {
    return (
      <Login />
    )
  }

  return (
    <div style={{ padding: 24 }}>
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
        <Header
          empresas={empresas}
          users={users}
          data={data}
          handleFilterChange={handleFilterChange}
          setPage={setPage}
        />

        { page === 'goals' && (
          <Goals
            goalOpen={goalOpen}
          />
        )}

        { page === 'goal' && (
          <GoalStepper 
            goalId={pageObjectId}
            setPage={setPage}
          />
        )}

        { page === 'admin' && (
          <>
            <Filter
              empresas={empresas}
              vendedores={users}
              sellers={users || []}
              onChange={handleFilterChange}
            />
            <Box display="flex" gap={2} mt={4}>
              <Box flex={3}>
                <AttendanceFlowChart operations={data?.operations || []} />
                <div style={{ marginTop: 16 }}>
                  <HorizontalBarReasons 
                    operations={data?.operations || []} 
                    params={startParams}
                  />
                </div>

                <div style={{ marginTop: 16 }}>
                  <SalesReport 
                    companies={[
                      {
                        id: 3, 
                        name: 'Boulevard'
                      },{
                        id: 2, 
                        name: 'Lupalina 01'
                      },
                    ]} 
                    data={goals}
                  />
                </div>

                <div style={{ marginTop: 16 }}>
                  <TimelineUsers 
                    operations={data?.operations || []} 
                    dialogOptions={startParams.dialogOptions} 
                    sellers={data?.users || []}
                  />
                </div>

              </Box>
              <Box flex={1}>
                <UsersCard 
                  users={data?.users || []} 
                  handleFilterChange={() => reaplicarFiltro()}
                />
              </Box>
            </Box>
          </>
        )}

      </LocalizationProvider>
    </div>
  );
  
};

export default Dashboard;
